import ClipboardJS from 'clipboard';
import { toggleClass } from '../utilities';

const shareableLink = () => {
  const shareableLinkButton = document.getElementById('shareableLinkButton');
  const shareableLinkInput = document.getElementById('shareableLinkUrl');

  if (!shareableLinkInput || !shareableLinkButton) {
    return;
  }

  const IS_SUCCESS = 'is-success';
  const defaultShareableHtml = shareableLinkButton.innerHTML;
  const copyButton = new ClipboardJS(shareableLinkButton);

  const selectInputText = (elem) =>
    elem.setSelectionRange(0, elem.value.length);

  const selectShareableUrl = () =>
    shareableLinkInput.addEventListener(
      'click',
      selectInputText.bind(null, shareableLinkInput)
    );

  const copyShareableLink = () => {
    copyButton.on('success', () => {
      if (shareableLinkButton.innerHTML === defaultShareableHtml) {
        toggleClass(IS_SUCCESS, shareableLinkButton);
        shareableLinkButton.setAttribute('disabled', true);
        shareableLinkButton.innerHTML =
          shareableLinkButton.getAttribute('data-disable-with');

        setTimeout(() => {
          shareableLinkButton.innerHTML = defaultShareableHtml;
          toggleClass(IS_SUCCESS, shareableLinkButton);
          shareableLinkButton.removeAttribute('disabled');
        }, 1500);
      }
    });
  };

  copyShareableLink();
  selectShareableUrl();
};

export default shareableLink;
